import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, Spin, Button } from "antd"; // Spin for loading indicator
import DocumentViewerModal from "./viewDocument";

const EvidenceList: React.FC = () => {
    const [evidenceData, setEvidenceData] = useState<any[]>([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const authToken = sessionStorage.getItem("token");
    const params = useParams<{ id: string }>();
    const { id: caseId } = params;
    const [isDocumentModalVisible, setIsDocumentModalVisible] = useState(false);
    const [documentUrl, setDocumentUrl] = useState<string | null>(null);

    // Fetch evidence
    const getEvidence = useCallback(
        async () => {
        try {
            setLoading(true);
            const response = await fetch(
                `https://backend-kyw8.onrender.com/cases/evidence?caseId=${caseId}`,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error ?? "An error occurred");
            }

            setEvidenceData(data.evidences);
        } catch (error) {
            console.error("Error fetching evidence:", error);
            toast.error("An unexpected error occurred. Please try again later.", {
                position: "bottom-right",
            });
        } finally {
            setLoading(false);
        }
    },[authToken, caseId])

    const handleViewDocument = (url: string) => {
        setDocumentUrl(url);
        setIsDocumentModalVisible(true);
    };

    useEffect(() => {
        if (isModalVisible) {
            getEvidence();
        }
    }, [getEvidence, isModalVisible]);

    return (
        <div>
            {/* Button to open evidence list modal */}
            <button className="flex justify-left font-bold" onClick={() => setIsModalVisible(true)}>
                Evidence List
            </button>

            {/* Evidence List Modal */}
            <Modal
                title="Evidence List"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width="80vw" // 80% width
                style={{ maxWidth: "900px", top: 20 }} // Prevents extreme width
            >
                {loading ? (
                    <div className="flex justify-center items-center">
                        <Spin size="large" />
                    </div>
                ) : (
                    <ul className="space-y-4">
                        {evidenceData.length > 0 ? (
                            evidenceData.map((item, index) => (
                                <li key={index} className="p-4 border rounded-lg shadow-sm">
                                    <p>
                                        <span className="font-bold">Name:</span> {item.name}
                                    </p>
                                    <p>
                                        <span className="font-bold">Description:</span> {item.description}
                                    </p>
                                    <p>
                                        <span className="font-bold">Created On:</span>{" "}
                                        {new Date(item.createdOn).toLocaleString()}
                                    </p>
                                    <Button
                                        type="primary"
                                        onClick={() => handleViewDocument(item.url)}
                                    >
                                        View Document
                                    </Button>
                                </li>
                            ))
                        ) : (
                            <p>No evidence documents available.</p>
                        )}
                    </ul>
                )}
            </Modal>

            {/* Document Viewer Modal */}
            <DocumentViewerModal
                documentUrl={documentUrl}
                isDocumentModalVisible={isDocumentModalVisible}
                closeModal={() => setIsDocumentModalVisible(false)}
            />
        </div>
    );
};

export default EvidenceList;
